var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49494 12.8891C7.77609 12.8891 6.84427 12.3566 6.84427 11.6378V7.56433H1.81236C1.09351 7.56433 0.454545 7.88382 0.454545 8.60263V18.3203C0.454545 19.0392 1.09351 19.8113 1.81236 19.8113H11.5301C12.2489 19.8113 12.7015 19.0392 12.7015 18.3203V12.8891H8.49494Z",
    fill: "current",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49494 12.8891C7.77609 12.8891 6.84427 12.3566 6.84427 11.6378V7.56433H1.81236C1.09351 7.56433 0.454545 7.88382 0.454545 8.60263V18.3203C0.454545 19.0392 1.09351 19.8113 1.81236 19.8113H11.5301C12.2489 19.8113 12.7015 19.0392 12.7015 18.3203V12.8891H8.49494Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57803 5.78127C6.57803 6.15948 6.29967 6.48367 5.93785 6.48367H1.09473C0.732885 6.48367 0.454545 6.18652 0.454545 5.78127V0.702397C0.454545 0.297168 0.732885 0 1.09473 0H5.93785C6.29967 0 6.57803 0.297168 6.57803 0.702397V5.78127Z",
    fill: "current",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57803 5.78127C6.57803 6.15948 6.29967 6.48367 5.93785 6.48367H1.09473C0.732885 6.48367 0.454545 6.18652 0.454545 5.78127V0.702397C0.454545 0.297168 0.732885 0 1.09473 0H5.93785C6.29967 0 6.57803 0.297168 6.57803 0.702397V5.78127Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5454 19.1478C19.5454 19.505 19.2998 19.8112 18.9805 19.8112H14.7072C14.3879 19.8112 14.1423 19.5306 14.1423 19.1478V14.3511C14.1423 13.9939 14.3879 13.6877 14.7072 13.6877H18.9805C19.2998 13.6877 19.5454 13.9684 19.5454 14.3511V19.1478Z",
    fill: "current",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5454 19.1478C19.5454 19.505 19.2998 19.8112 18.9805 19.8112H14.7072C14.3879 19.8112 14.1423 19.5306 14.1423 19.1478V14.3511C14.1423 13.9939 14.3879 13.6877 14.7072 13.6877H18.9805C19.2998 13.6877 19.5454 13.9684 19.5454 14.3511V19.1478Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5454 10.9424C19.5454 11.6612 18.9597 12.2469 18.2408 12.2469H8.60303C7.88418 12.2469 7.29848 11.6612 7.29848 10.9424V1.30457C7.29848 0.585724 7.88418 0 8.60303 0H18.2408C18.9597 0 19.5454 0.585724 19.5454 1.30457V10.9424Z",
    fill: "current",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5454 10.9424C19.5454 11.6612 18.9597 12.2469 18.2408 12.2469H8.60303C7.88418 12.2469 7.29848 11.6612 7.29848 10.9424V1.30457C7.29848 0.585724 7.88418 0 8.60303 0H18.2408C18.9597 0 19.5454 0.585724 19.5454 1.30457V10.9424Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/comp.becbc32e0ec46b83a6a8e29d7b56ba69.svg";
export { ForwardRef as ReactComponent };